import * as types from '../../../constants/actionTypes';
import uriTemplate from 'uri-template';
import api from '../../../../shared/api.json';

export function fetchSubCompanies(profileId) {
    const url = uriTemplate
        .parse(api.profiles.subCompanies.index)
        .expand({ profileId });

    return {
        types: [
            types.CONNECTED_COMPANIES_FETCH_ALL,
            types.CONNECTED_COMPANIES_FETCH_ALL_SUCCESS,
            types.CONNECTED_COMPANIES_FETCH_ALL_FAIL,
        ],
        promise: (client) => client.get(url),
    };
}

export function connectSubCompany(profileId, companyId) {
    const url = uriTemplate
        .parse(api.profiles.subCompanies.index)
        .expand({ profileId });

    return {
        types: [
            types.CONNECTED_COMPANIES_ADD,
            types.CONNECTED_COMPANIES_ADD_SUCCESS,
            types.CONNECTED_COMPANIES_ADD_FAIL,
        ],
        promise: (client) => client.post(url, { data: { companyId } }),
        meta: { companyId },
    };
}

export function disconnectSubCompany(profileId, companyId) {
    const url = uriTemplate.parse(api.profiles.subCompanies.subCompany).expand({
        profileId,
        companyId,
    });

    return {
        types: [
            types.CONNECTED_COMPANIES_DELETE,
            types.CONNECTED_COMPANIES_DELETE_SUCCESS,
            types.CONNECTED_COMPANIES_DELETE_FAIL,
        ],
        promise: (client) => client.del(url),
        meta: { companyId },
    };
}
